// hooks/useUserPresence.js

import { doc, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase/firebase.utils";
import { useEffect } from "react";

export const useUserPresence = (currentUser) => {
  useEffect(() => {
    if (!currentUser?.uid) return;

    const updatePresence = async () => {
      try {
        // Check localStorage for last update time
        const lastUpdate = localStorage.getItem("lastPresenceUpdate");
        const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;

        // Only update if more than 5 minutes have passed
        if (!lastUpdate || parseInt(lastUpdate) < fiveMinutesAgo) {
          await updateDoc(doc(db, "users", currentUser?.uid), {
            lastEntered: new Date(),
          });
          localStorage.setItem("lastPresenceUpdate", Date.now().toString());
        }
      } catch (error) {
        console.error("Presence update error:", error);
      }
    };

    // Update on mount
    updatePresence();

    // Optional: Update when window gets focus (user returns to tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        updatePresence();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentUser?.uid]); // Only re-run if UID changes
};
